import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react';
import clsx from 'clsx';
import styles from './Pill.style';

const Pill = ({ children, className: classNameProp, ...other }) => {
  const className = clsx(styles.root, classNameProp);

  return (
    <div className={className} {...other}>
      <Text variant="small" className={styles.text}>
        {children}
      </Text>
    </div>
  );
};

Pill.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Pill.defaultProps = {
  children: '',
  className: '',
};

export default Pill;
